import type { Instance, Server } from './api';
import { corrisponde } from '../routes/entra';
import { t } from './lingua';

/**
 * La lista dei server si cerca e si filtra: con dieci macchine si guarda,
 * con quaranta si cerca. Il testo trova nome, indirizzi, provider, regione,
 * versioni di Odoo e nomi delle istanze — «19», «acme», «GRA» — e i chip
 * rispondono alle tre domande da lunedì mattina: cosa c'è da aggiornare,
 * cosa ha un avviso acceso, cosa non è ancora pronto.
 */
export interface VistaServer {
  server: Server;
  istanze: Instance[];
  /** Gli avvisi accesi su questo server. */
  avvisi: number;
}

export type Chip = 'aggiornare' | 'avvisi' | 'nonPronti';

/** Le versioni di Odoo che girano sul server, senza doppioni, dalla più nuova. */
export function majorDi(v: VistaServer): string[] {
  return [...new Set(v.istanze.map((i) => i.odooMajor))].sort().reverse();
}

/**
 * Cosa c'è da fare su un server: i passi nuovi dell'installazione da
 * applicare, e le istanze il cui Odoo è indietro rispetto al ramo. Vuoto
 * vuol dire niente.
 */
export function daFare(v: VistaServer): string[] {
  const out: string[] = [];
  const s = v.server;
  if (s.status === 'ready' && s.totalSteps > s.progress) {
    const nuovi = s.totalSteps - s.progress;
    out.push(nuovi === 1 ? t('1 passo nuovo') : t('{n} passi nuovi', { n: nuovi }));
  }
  const indietro = v.istanze.filter((i) => (i.code?.behind ?? 0) > 0).length;
  if (indietro > 0) {
    out.push(indietro === 1 ? t('1 istanza con Odoo da aggiornare') : t('{n} istanze con Odoo da aggiornare', { n: indietro }));
  }
  return out;
}

export function filtraServer(viste: VistaServer[], testo: string, chips: Set<Chip>): VistaServer[] {
  return viste.filter((v) => {
    const s = v.server;
    if (chips.has('aggiornare') && daFare(v).length === 0) return false;
    if (chips.has('avvisi') && v.avvisi === 0) return false;
    if (chips.has('nonPronti') && s.status === 'ready') return false;
    if (!testo.trim()) return true;
    const major = majorDi(v);
    return corrisponde(
      testo,
      s.name, s.ipv4 ?? '', s.failoverIpv4 ?? '', s.provider, s.region ?? '', s.status,
      ...major, ...major.map((m) => m.replace(/\.0$/, '')),
      ...v.istanze.map((i) => i.name),
    );
  });
}
